<template>
    <div>
        <PreSaleForwardDeliveryList userType="E" />
    </div>
</template>

<script>
import PreSaleForwardDeliveryList from '../../preSale-management/preSale-order/preSale-forward-delivery-list';

export default {
    name: 'inner-sale-list',
    components: {
        PreSaleForwardDeliveryList
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
